import { ArrayElement, OnlyArrayKeys } from './../../../../models/types'
import {
  CONFIGURACAO_KANBAN,
  InvalidsRegisterEtapas,
  InvalidsRegisterPipelines,
  InvalidsRegisterSLAs,
  RegisterEtapas,
  RegisterPipelines,
  RegisterSLAs,
  RegraEscalacao,
  TYPES
} from './types'

export const setActiveTab = (value: number) => ({
  type: TYPES.SET_ACTIVE_TAB,
  value
})

export const setConfiguracaoKanban = (value: boolean) => ({
  type: TYPES.SET_CONFIGURACAO_KANBAN,
  value
})

export const setPipelinesTabEtapas = (
  value: CONFIGURACAO_KANBAN['tabEtapas']['pipelines']
) => ({
  type: TYPES.SET_PIPELINES_TAB_ETAPAS,
  value
})

export const cleanPipelinesTabEtapas = () => ({
  type: TYPES.CLEAN_PIPELINES_TAB_ETAPAS
})

export const setEtapasPipelineTabEtapas = (
  value: CONFIGURACAO_KANBAN['tabEtapas']['etapasPipeline']
) => ({
  type: TYPES.SET_ETAPAS_PIPELINES_TAB_ETAPAS,
  value
})

export const cleanEtapasPipelineTabEtapas = () => ({
  type: TYPES.CLEAN_ETAPAS_PIPELINES_TAB_ETAPAS
})

export const setRegisterTabEtapas = (
  value: CONFIGURACAO_KANBAN['tabEtapas']['register']
) => ({
  type: TYPES.SET_REGISTER_TAB_ETAPAS,
  value
})

type RegisterFields = keyof RegisterEtapas
export const setRegisterFieldsTabEtapas = <T extends RegisterFields>(
  value: RegisterEtapas[T],
  field: T
) => ({
  type: TYPES.SET_REGISTER_FIELDS_TAB_ETAPAS,
  value,
  field
})

export const setRegisterEtapasPermitidasTabEtapas = (value: string) => ({
  type: TYPES.SET_REGISTER_ETAPAS_PERMITIDAS_TAB_ETAPAS,
  value
})

export const cleanRegisterTabEtapas = () => ({
  type: TYPES.CLEAN_REGISTER_TAB_ETAPAS
})

type InvalidFieldsEtapas = keyof InvalidsRegisterEtapas
export const setInvalidsFieldsRegisterTabEtapas = <
  T extends InvalidFieldsEtapas
>(
  value: InvalidsRegisterEtapas[T],
  field: T
) => ({
  type: TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_ETAPAS,
  value,
  field
})

export const cleanInvalidsRegisterTabEtapas = () => ({
  type: TYPES.CLEAN_INVALIDS_REGISTER_TAB_ETAPAS
})

export const setEtapasPermitidasTabEtapas = (
  value: CONFIGURACAO_KANBAN['tabEtapas']['etapasPermitidas']
) => ({
  type: TYPES.SET_ETAPAS_PERMITIDAS_TAB_ETAPAS,
  value
})

export const setVisualizacaoTabEtapas = (
  value: CONFIGURACAO_KANBAN['tabEtapas']['visualizacao']
) => ({
  type: TYPES.SET_VISUALIZACAO_TAB_ETAPAS,
  value
})

export const setPipelineSelecionadoTabEtapas = (value: string | null) => ({
  type: TYPES.SET_PIPELINE_SELECIONADO_TAB_ETAPAS,
  value
})

export const setEtapaPipelineSelecionadoTabEtapas = (value: string | null) => ({
  type: TYPES.SET_ETAPA_PIPELINE_SELECIONADO_TAB_ETAPAS,
  value
})

export const getConfiguracaoKanbanSaga = () => ({
  type: TYPES.GET_CONFIGURACAO_KANBAN_SAGA
})

export const getPipelinesTabEtapasSaga = () => ({
  type: TYPES.GET_PIPELINES_TAB_ETAPAS_SAGA
})

export const getEtapasPipelineTabEtapasSaga = (id: string) => ({
  type: TYPES.GET_ETAPAS_PIPELINE_TAB_ETAPAS_SAGA,
  id
})

export const getEtapaByIdTabEtapasSaga = (id: string) => ({
  type: TYPES.GET_ETAPA_BY_ID_TAB_ETAPAS_SAGA,
  id
})

export const getEtapasPermitidasTabEtapasSaga = (id: string) => ({
  type: TYPES.GET_ETAPAS_PERMITIDAS_TAB_ETAPAS_SAGA,
  id
})

export const salvarEtapaTabEtapasSaga = () => ({
  type: TYPES.SALVAR_ETAPA_TAB_ETAPAS_SAGA
})

export const editarEtapaTabEtapasSaga = () => ({
  type: TYPES.EDITAR_ETAPA_TAB_ETAPAS_SAGA
})

export const removerEtapaTabEtapasSaga = (id: string) => ({
  type: TYPES.REMOVER_ETAPA_TAB_ETAPAS_SAGA,
  id
})

export const alterarOrdemEtapaTabEtapasSaga = ({
  id,
  ordem
}: {
  id: string
  ordem: number
}) => ({
  type: TYPES.ALTERAR_ORDEM_ETAPA_TAB_ETAPAS_SAGA,
  id,
  ordem
})

/****************** TAB SLAs ******************/

export const setBignumbersTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['bigNumbers']
) => ({
  type: TYPES.SET_BIGNUMBERS_TAB_SLAS,
  value
})

export const setRegisterTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['register']
) => ({
  type: TYPES.SET_REGISTER_TAB_SLAS,
  value
})

type RegisterFieldsSLAs = keyof RegisterSLAs
export const setRegisterFieldsTabSLAs = <T extends RegisterFieldsSLAs>(
  value: RegisterSLAs[T],
  field: T
) => ({
  type: TYPES.SET_REGISTER_FIELDS_TAB_SLAS,
  value,
  field
})

type RegraEscalacaoFields = keyof RegraEscalacao
export const setRegisterRegrasEscalacaoTabSLAs = <
  T extends RegraEscalacaoFields
>(
  value: RegraEscalacao[T],
  field: T,
  index: number
) => ({
  type: TYPES.SET_REGISTER_REGRAS_ESCALACAO_TAB_SLAS,
  value,
  field,
  index
})

export const adicionarRegisterRegrasEscalacaoTabSLAs = () => ({
  type: TYPES.ADICIONAR_REGISTER_REGRAS_ESCALACAO_TAB_SLAS
})

export const removerRegisterRegrasEscalacaoTabSLAs = (index: number) => ({
  type: TYPES.REMOVER_REGISTER_REGRAS_ESCALACAO_TAB_SLAS,
  index
})

export const cleanRegisterTabSLAs = () => ({
  type: TYPES.CLEAN_REGISTER_TAB_SLAS
})

export const setInvalidsRegisterTabSLAs = (value: InvalidsRegisterSLAs) => ({
  type: TYPES.SET_INVALIDS_REGISTER_TAB_SLAS,
  value
})

type InvalidFieldsSLAs = keyof InvalidsRegisterSLAs
export const setInvalidsFieldsRegisterTabSLAs = <T extends InvalidFieldsSLAs>(
  value: InvalidsRegisterSLAs[T],
  field: T
) => ({
  type: TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_SLAS,
  value,
  field
})

export const setInvalidsArrayFieldRegisterTabSLAs = <
  T extends OnlyArrayKeys<InvalidsRegisterSLAs> & keyof InvalidsRegisterSLAs,
  K extends keyof ArrayElement<InvalidsRegisterSLAs[T]>
>(
  value: ArrayElement<InvalidsRegisterSLAs[T]>[K],
  field: T,
  index: number,
  nestedField: K
) => ({
  type: TYPES.SET_INVALIDS_FIELDS_REGISTER_ARRAY_TAB_SLAS,
  value,
  field,
  index,
  nestedField
})

export const cleanInvalidsRegisterTabSLAs = () => ({
  type: TYPES.CLEAN_INVALIDS_REGISTER_TAB_SLAS
})

export const setPipelinesTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['pipelines']
) => ({
  type: TYPES.SET_PIPELINES_TAB_SLAS,
  value
})

export const setEtapasTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['etapas']
) => ({
  type: TYPES.SET_ETAPAS_TAB_SLAS,
  value
})

export const setAcoesTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['acoes']
) => ({
  type: TYPES.SET_ACOES_TAB_SLAS,
  value
})

export const setVisualizacaoTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['visualizacao']
) => ({
  type: TYPES.SET_VISUALIZACAO_TAB_SLAS,
  value
})

export const setSLAsConfiguradosTabSLAs = (
  value: CONFIGURACAO_KANBAN['tabSLAs']['slasConfigurados']
) => ({
  type: TYPES.SET_SLAS_CONFIGURADOS_TAB_SLAS,
  value
})

export const cleanSLAsConfiguradosTabSLAs = () => ({
  type: TYPES.CLEAN_SLAS_CONFIGURADOS_TAB_SLAS
})

export const getBigNumbersTabSLAsSaga = () => ({
  type: TYPES.GET_BIGNUMBERS_TAB_SLAS_SAGA
})

export const getSlaByIdTabSLAsSaga = (id: string) => ({
  type: TYPES.GET_SLA_BY_ID_TAB_SLAS_SAGA,
  id
})

export const getPipelinesTabSLAsSaga = () => ({
  type: TYPES.GET_PIPELINES_TAB_SLAS_SAGA
})

export const getEtapasTabSLAsSaga = () => ({
  type: TYPES.GET_ETAPAS_TAB_SLAS_SAGA
})

export const getAcoesTabSLAsSaga = () => ({
  type: TYPES.GET_ACOES_TAB_SLAS_SAGA
})

export const salvarSlaTabSLAsSaga = () => ({
  type: TYPES.SALVAR_SLA_TAB_SLAS_SAGA
})

export const editarSlaTabSLAsSaga = () => ({
  type: TYPES.EDITAR_SLA_TAB_SLAS_SAGA
})

export const getSLAsConfiguradosTabSLAsSaga = () => ({
  type: TYPES.GET_SLAS_CONFIGURADOS_TAB_SLAS_SAGA
})

export const removerSlaConfiguradoTabSLAsSaga = (id: string) => ({
  type: TYPES.REMOVER_SLA_CONFIGURADO_TAB_SLAS_SAGA,
  id
})

/************* TAB PIPELINES ******************/

export const setPipelinesTabPipelines = (
  value: CONFIGURACAO_KANBAN['tabPipelines']['pipelines']
) => ({
  type: TYPES.SET_PIPELINES_TAB_PIPELINES,
  value
})

type PaginationFields = keyof CONFIGURACAO_KANBAN['tabPipelines']['pagination']
export const setPaginationTabPipelines = <T extends PaginationFields>(
  value: CONFIGURACAO_KANBAN['tabPipelines']['pagination'][T],
  field: T
) => ({
  type: TYPES.SET_PAGINATION_TAB_PIPELINES,
  value,
  field
})

export const cleanPipelinesTabPipelines = () => ({
  type: TYPES.CLEAN_PIPELINES_TAB_PIPELINES
})

export const setRegisterTabPipelines = (
  value: CONFIGURACAO_KANBAN['tabPipelines']['register']
) => ({
  type: TYPES.SET_REGISTER_TAB_PIPELINES,
  value
})

type RegisterFieldsPipelines = keyof RegisterPipelines
export const setRegisterFieldsTabPipelines = <
  T extends RegisterFieldsPipelines
>(
  value: RegisterPipelines[T],
  field: T
) => ({
  type: TYPES.SET_REGISTER_FIELDS_TAB_PIPELINES,
  value,
  field
})

export const cleanRegisterTabPipelines = () => ({
  type: TYPES.CLEAN_REGISTER_TAB_PIPELINES
})

export const setVisualizacaoTabPipelines = (
  value: CONFIGURACAO_KANBAN['tabPipelines']['visualizacao']
) => ({
  type: TYPES.SET_VISUALIZACAO_TAB_PIPELINES,
  value
})

type InvalidFieldsPipelines = keyof InvalidsRegisterPipelines
export const setInvalidsFieldsRegisterTabPipelines = <
  T extends InvalidFieldsPipelines
>(
  value: InvalidsRegisterPipelines[T],
  field: T
) => ({
  type: TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_PIPELINES,
  value,
  field
})

export const cleanInvalidsRegisterTabPipelines = () => ({
  type: TYPES.CLEAN_INVALIDS_REGISTER_TAB_PIPELINES
})

export const setPipelineSelecionadoTabPipelines = (value: string | null) => ({
  type: TYPES.SET_PIPELINE_SELECIONADO_TAB_PIPELINES,
  value
})

export const cleanPipelineSelecionadoTabPipelines = () => ({
  type: TYPES.CLEAN_PIPELINE_SELECIONADO_TAB_PIPELINES
})

type SearchFields = keyof CONFIGURACAO_KANBAN['tabPipelines']['search']
export const setSearchTabPipelines = <T extends SearchFields>(
  value: CONFIGURACAO_KANBAN['tabPipelines']['search'][T],
  field: T
) => ({
  type: TYPES.SET_SEARCH_TAB_PIPELINES,
  value,
  field
})

export const cleanSearchTabPipelines = () => ({
  type: TYPES.CLEAN_SEARCH_TAB_PIPELINES
})

export const setModalRegisterIsOpenTabPipelines = (value: boolean) => ({
  type: TYPES.SET_MODAL_REGISTER_IS_OPEN_PIPELINES,
  value
})

type OptionsSelectTabPipelinesFields =
  keyof CONFIGURACAO_KANBAN['tabPipelines']['optionsSelect']
export const setOptionsSelectTabPipelines = <
  T extends OptionsSelectTabPipelinesFields
>(
  value: CONFIGURACAO_KANBAN['tabPipelines']['optionsSelect'][T],
  field: T
) => ({
  type: TYPES.SET_OPTIONS_SELECT_TAB_PIPELINES,
  value,
  field
})

export const getPipelinesTabPipelinesSaga = () => ({
  type: TYPES.GET_PIPELINES_TAB_PIPELINES_SAGA
})

export const getPipelineByIdTabPipelinesSaga = (id: string) => ({
  type: TYPES.GET_PIPELINE_BY_ID_TAB_PIPELINES_SAGA,
  id
})

export const editarPipelineTabPipelinesSaga = () => ({
  type: TYPES.EDITAR_PIPELINE_TAB_PIPELINES_SAGA
})

export const salvarPipelineTabPipelinesSaga = () => ({
  type: TYPES.SALVAR_PIPELINE_TAB_PIPELINES_SAGA
})

export const removerPipelineTabPipelinesSaga = (id: string) => ({
  type: TYPES.REMOVER_PIPELINE_TAB_PIPELINES_SAGA,
  id
})

export const alterarStatusPipelineTabPipelinesSaga = (
  id: string,
  status: boolean
) => ({
  type: TYPES.ALTERAR_STATUS_PIPELINE_TAB_PIPELINES_SAGA,
  id,
  status
})

export const duplicarPipelineTabPipelinesSaga = (id: string) => ({
  type: TYPES.DUPLICAR_PIPELINE_TAB_PIPELINES_SAGA,
  id
})

export const getCentrosCustoTabPipelinesSaga = () => ({
  type: TYPES.GET_CENTROS_CUSTO_TAB_PIPELINES_SAGA
})
